import { createGlobalStyle, falconTheme } from '@secretescapes/falcon';

export const GlobalDesktopStyles = createGlobalStyle`
  body {
    background: ${falconTheme.color.white};
    overflow-x: hidden;
  }

  #root {
    max-width: 100vw;
  }
`;
